import { z } from 'zod';
import { AuditSchema } from './entities/audit.schema';


/**
 * Content Summary schema for lightweight listing.
 */
export const ContentSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  preview: z.string().describe('A plain text preview (approx 2 lines) of the prose.'),
  notes: z.string().optional().describe('Internal notes for this content variant.'),
  chapterId: z.string().nullable().optional(),
  sceneIds: z.array(z.string()).default([]),
  wordCount: z.number().int().default(0).describe('Total word count of this content.'),
  updatedAt: z.string().datetime(),
});

export type ContentSummary = z.infer<typeof ContentSummarySchema>;

/**
 * Full Content Document schema.
 */
export const ContentDocumentSchema = z.object({
  id: z.string(),
  name: z.string(),
  notes: z.string().optional().describe('Internal notes for this content variant.'),
  scratchpad: z.string().describe('The full prose content.'),
  scratchpadVersion: z.number().int(),
  currentDayKey: z.string(),
  chapterId: z.string().nullable().optional(),
  sceneIds: z.array(z.string()).default([]),
  wordCount: z.number().int().default(0).describe('Total word count of this content.'),
  audit: AuditSchema,
  // history is handled by separate collections (diffs/snapshots)
});

export type ContentDocument = z.infer<typeof ContentDocumentSchema>;
